import React, { useMemo } from 'react';
import { Result } from 'true-myth';
import { ISortInfo } from '../../../BaseComponents/Table/Components/SortableTableUtils';
import {
  IBusinessCollectionQueryResult,
  ICollectionDataType,
} from '../_Common/Components/BusinessCollectionComponents/Queries/BusinessCollectionQuery';
import { IFilterAttribute } from '../_Common/Const/Delsystem';

interface IStandardRutinCollectionContext {
  sortInfo: ISortInfo<ICollectionDataType>;
  filteredSortInfo: ISortInfo<ICollectionDataType>;
  updateSortInfo: (info: ISortInfo<ICollectionDataType>) => void;
  collectionQueryResult: IBusinessCollectionQueryResult;
  searchText: string;
  setSearchText: React.Dispatch<React.SetStateAction<string>>;
  filterAttributes: IFilterAttribute[] | undefined;
}

export const StandardRutinCollectionContext =
  React.createContext<IStandardRutinCollectionContext>({
    sortInfo: { rows: [], properties: [] },
    filteredSortInfo: { rows: [], properties: [] },
    updateSortInfo: () => {},
    collectionQueryResult: {
      data: null,
      loading: false,
      query: Result.err('No context provider'),
      refetch: () => {},
      serverError: undefined,
    },
    filterAttributes: [],
    searchText: '',
    setSearchText: () => {},
  });

export const StandardRutinCollectionContextProvider: React.FC<
  React.PropsWithChildren<IStandardRutinCollectionContext>
> = props => {
  const value: IStandardRutinCollectionContext = useMemo(
    () => ({
      sortInfo: props.sortInfo,
      filteredSortInfo: props.filteredSortInfo,
      updateSortInfo: props.updateSortInfo,
      collectionQueryResult: props.collectionQueryResult,
      searchText: props.searchText,
      setSearchText: props.setSearchText,
      filterAttributes: props.filterAttributes,
    }),
    [
      props.sortInfo,
      props.filteredSortInfo,
      props.updateSortInfo,
      props.collectionQueryResult,
      props.searchText,
      props.setSearchText,
      props.filterAttributes,
    ]
  );

  return (
    <StandardRutinCollectionContext.Provider value={value}>
      {props.children}
    </StandardRutinCollectionContext.Provider>
  );
};
